<template>
	<Autocomplete
		v-model="selected"
		:display-name="label"
		:icon="icon"
		:label="label"
		:endpoint="endpoint"
		:name="name"
		:item-title="itemTitle"
		data-test="teams-autocomplete"
		v-bind="$attrs"
	>
	</Autocomplete>
</template>

<script setup lang="ts">
import { personBuildFullname } from '@/filters'
import { useTranslate } from 'composables/useTranslate.ts'
import Autocomplete from '../Validation/Autocomplete.vue'

const { translate } = useTranslate()

// Die Optionen enthalten nur aktive Mitglieder. Ein deaktiviertes taucht hier
// deshalb nur als bereits gebundener Wert auf (returnObject) — dann soll man ihm
// ansehen, dass der Zugang beendet ist.
const itemTitle = (item: Api.Team) => {
	const name = personBuildFullname(item, { isTeam: true })
	if (item?.active !== false) return name
	return `${name} (${translate('component.teams.inactive')})`
}

const { endpoint } = defineProps({
	name: {
		default: 'teams',
		type: String,
	},
	icon: {
		default: 'fa-regular fa-chalkboard-teacher',
		type: String,
	},
	label: {
		default: 'component.teams.teamMember',
		type: String,
	},
	endpoint: {
		default: 'teams',
		type: String,
	},
	setFilterToSelf: {
		type: Boolean,
		default: false,
	},
})

const selected = defineModel()
</script>

<style scoped></style>
